import {
  CommonErrorMessage,
  CommonPopupCrud,
  dateTimeFormat,
  MuiDataGrid,
} from "@common";
// ==================================================================================================================
  function getUpdatedByRole(value1, row) {
    const value = row?.user_role_data;
    return `${value?.roleCode || "NA"}-${value?.roleName || "NA"}`;
  }
  function getUpdatedBy(value, row) {
    return row?.user_updated?.email;
  }
const CommonStatusHistory = ({ showUpdateByRole, ...props }) => {

  const StatusHistorydata = {
    rows: props?.data ?? [],
    columns: [
      {
        field: "status",
        headerName: "Status",
        renderHeader: () => <strong>Status</strong>,
        width: 200,
      },
      showUpdateByRole && {
        field: "updatedByRole",
        headerName: "Updated By Role",
        renderHeader: () => <strong>Updated By Role</strong>,
        width: 180,
        valueGetter: getUpdatedByRole,
      },
      {
        field: "updatedBy",
        headerName: "Updated By",
        renderHeader: () => <strong>Updated By</strong>,
        width: 290,
        valueGetter: getUpdatedBy,
      },
      {
        field: "updatedOn",
        headerName: "Updated On",
        renderHeader: () => <strong>Updated On</strong>,
        valueGetter: (value, row) => {
          return dateTimeFormat(row?.updatedOn);
        },
        width: 270,
      },
    ],
  };

  try {
    return (
      <CommonPopupCrud
        largeScreen={true}
        close={props.close}
        heading="Status History"
        buttonAlignRight={true}
        cancelButtonName="Close"
      >
        <MuiDataGrid data={StatusHistorydata} customHeight="60vh" />
      </CommonPopupCrud>
    );
  } catch (err) {
    console.log(err);
    return <CommonErrorMessage />;
  }
};

export default CommonStatusHistory;
